module.exports = __webpack_public_path__ + "images/xibao_top_backview_2026-2027.1789545008192.jpg";